import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, usePermission } from '@np/np_webcomponentlib'

import { API_AUTH } from '../../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType } from './TokenFormTypes'





export const TokenForm = ({ idBusiness }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    // Функция для форматирования даты в формат dd.mm.yyyy
    const formatExpirationDate = (dateString: string) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    // Функция для определения цвета фона в зависимости от срока истечения
    const getExpirationDateColor = (dateString: string) => {
        const expirationDate = new Date(dateString);
        const currentDate = new Date();
        const diffTime = expirationDate.getTime() - currentDate.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
            return '#8B0000'; // Темно-красный если дата уже прошла
        } else if (diffDays < 7) {
            return '#FFA500'; // Оранжевый если меньше 7 дней
        } else if (diffDays < 30) {
            return '#FFD700'; // Желтый если меньше месяца
        } else {
            return '#28a745'; // Зеленый если больше месяца
        }
    };

    const [currentIDBusiness, setCurrentIDBusiness] = useState<string>(idBusiness)
    const [entity, setEntity] = useState<EntityType | DataEntityType>()
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        setCurrentIDBusiness(idBusiness)
    }, [idBusiness])

    const [, doFetchLoad] = useFetch(
        `${API_AUTH}directtoken/info/${currentIDBusiness}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    
        const [, doFetchRenewal] = useFetch(
            `${API_AUTH}directtoken/renewal`)//{ error: errCU, isLoading: isLoadCU, response: respCU }



    useEffect(() => {
        if (!currentIDBusiness || currentIDBusiness === "") {
            return
        }
        setIsLoading(true)
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
            console.log(responce.data)
        }).catch(error => {
            console.error('Error loading token data:', error)
            setEntity(undefined)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [currentIDBusiness])


    const updateButtonTitle = "Перевыпустить токены"//useTranslation('renewalButton')

    const handleRenewalToken = () => {
        if (!currentIDBusiness || currentIDBusiness === "") {
            return
        }
        setIsLoading(true)
        doFetchRenewal({
            method: 'POST',
            data: {
                idrfBusiness: currentIDBusiness
            }
        }).then(response => {
            setEntity(response.data)
            console.log('Token renewed successfully:', response.data)
        }).catch(error => {
            console.error('Error renewing token:', error)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const formattedText = entity ? `
  ----------------------------------------------------------------------------
  JWT_TOKEN: ${entity.token || 'Не задан'}
  JWT_TOKEN_FOR_WEBHOOK: ${entity.tokenForWebhook || 'Не задан'}
  ----------------------------------------------------------------------------
  ` : '';

    if (!currentIDBusiness || currentIDBusiness === "") {
        return (
            <Card>
                <Card.Body>
                    <div>Не указан ID бизнеса для загрузки токенов</div>
                </Card.Body>
            </Card>
        );
    }

    if (isLoading) {
        return (
            <Card>
                <Card.Body>
                    <div>Загрузка данных токенов...</div>
                </Card.Body>
            </Card>
        );
    }

    return (<Card>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

        

            <Row className="mb-4">
                <Form.Label className="col-md-3">{"Данные токенов"}</Form.Label>
                <Col md={9}>
                    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
                        {formattedText || "Нет данных"}
                    </pre>
                </Col>
            </Row>


            
            <Row className="mb-4">
                <Form.Label className="col-md-3">{"Дата истечения токена"}</Form.Label>
                <Col md={9}>
                    {entity?.expirationDate ? (
                        <span style={{ 
                            backgroundColor: getExpirationDateColor(entity.expirationDate),
                            padding: '4px 8px',
                            borderRadius: '4px',
                            color: 'white',
                            fontWeight: 'bold'
                        }}>
                            {formatExpirationDate(entity.expirationDate)}
                        </span>
                    ) : "Нет данных"}
                </Col>
            </Row>

            <Row className="mb-4">
                <Col md={3}></Col>
                <Col md={9}>
                    <Button 
                        variant="primary" 
                        onClick={handleRenewalToken}
                        disabled={isLoading || !currentIDBusiness}
                    >
                        {isLoading ? "Обновление..." : updateButtonTitle}
                    </Button>
                </Col>
            </Row>


            


        </Card.Body>
    </Card>)
}
